import { Button, DropDownButton, } from '@innovyze/stylovyze/lib/components';
import Text from '@innovyze/stylovyze/lib/components/Text';
import React from 'react';
import Pagination from './Pagination/Pagination';
import { CustomFooter, FooterCell, FooterCellAction, } from './StylovyzeTable.styles';
import { useGlobalization } from '../../contexts/GlobalizationProvider/useGlobalization';
const StylovyzeTableFooter = ({ pagination, rowsPerPage, footerItems, footerArea, }) => {
    {
        const { t } = useGlobalization();
        return (React.createElement(CustomFooter, { container: true },
            pagination && rowsPerPage && (React.createElement(FooterCell, { flexGrow: 1 },
                React.createElement(Text, { variant: "text-large" }, rowsPerPage.title
                    ? rowsPerPage.title
                    : t('Rows per page:')),
                React.createElement(DropDownButton, { arrow: true, color: "secondary", options: rowsPerPage.options, placement: "bottom-start", variant: "text", initialSelectedIndex: rowsPerPage.selectedIndex, popupZIndex: rowsPerPage.popupZIndex }))),
            pagination && (React.createElement(FooterCell, { flexGrow: 1 },
                React.createElement(Pagination, { currentPage: pagination.currentPage, totalNumberOfPages: pagination.totalNumberOfPages, dataCy: pagination.dataCy, onChange: pagination.onChange, padding: "unset", extraInfo: pagination.extraInfo }))),
            footerItems && footerItems.length > 0 && (React.createElement(FooterCellAction, null, footerItems.map(({ props, onClick, disabled, content }, key) => (React.createElement(Button, { ...props, key: key, onClick: onClick, disabled: disabled }, content))))),
            pagination == undefined &&
                footerItems == undefined &&
                footerArea && React.createElement(React.Fragment, null, footerArea)));
    }
};
export default StylovyzeTableFooter;
